import { SkeletonType } from '@com/enums/model'

/*
ꔷ 人形骨骼校验规则
- 模型网格数量=1
- 骨骼数量 = 【蓝本模型骨骼结构】
- 骨骼类型名称=【蓝本模型骨骼结构】
‒ 骨骼结构=【蓝本模型骨骼结构】
- 材质数量=1
- 蒙皮数量=1
‒ 是否带有：顶点 、法线、0号纹理坐标等信息
ꔷ 鱼类/鸟类/爬行类/蛇类/简易骨骼、校验规则
- 模型网格数量=1
- 骨骼数量 = 【蓝本模型骨骼结构】
- 骨骼类型名称=【蓝本模型骨骼结构】
‒ 骨骼结构=【蓝本模型骨骼结构】
- 材质数量=1
- 蒙皮数量=1
‒ 是否带有：顶点 、法线、0号纹理坐标信息 都为true
ꔷ \ 校验规则
- 模型网格数量=1
- 材质数量=1
‒ 是否带有：顶点 、法线、0号纹理坐标信息 都为true
ꔷ 无骨骼校验规则
- 模型网格数量=1
- 材质数量=1
‒ 是否带有：顶点 、法线、0号纹理坐标信息 都为true
 */
export const humanoidSkeleton = [
  'Bip001',
  'Bip001/Bip001_Pelvis',
  'Bip001/Bip001_Pelvis/Bip001_Spine',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck/Bip001_Head',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand/Bip001_L_Finger0',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand/Bip001_L_Finger0/Bip001_L_Finger01',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand/Bip001_L_Finger1',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand/Bip001_L_Finger1/Bip001_L_Finger11',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand/Bip001_R_Finger0',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand/Bip001_R_Finger0/Bip001_R_Finger01',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand/Bip001_R_Finger1',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand/Bip001_R_Finger1/Bip001_R_Finger11',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh/Bip001_L_Calf',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh/Bip001_L_Calf/Bip001_L_Foot',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh/Bip001_R_Calf',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh/Bip001_R_Calf/Bip001_R_Foot',
]

export const reptilesSkeleton = [
  'Bip001',
  'Bip001/Bip001_Pelvis',
  'Bip001/Bip001_Pelvis/Bip001_Spine',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck/Bip001_Neck1',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck/Bip001_Neck1/Bip001_Head',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck/Bip001_Neck1/Bip001_Head/Bip001_Mouth',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_L_Clavicle/Bip001_L_UpperArm/Bip001_L_Forearm/Bip001_L_Hand/Bip001_L_Finger0',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand',
  'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_R_Clavicle/Bip001_R_UpperArm/Bip001_R_Forearm/Bip001_R_Hand/Bip001_R_Finger0',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh/Bip001_L_Calf',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh/Bip001_L_Calf/Bip001_L_Foot',
  'Bip001/Bip001_Pelvis/Bip001_L_Thigh/Bip001_L_Calf/Bip001_L_Foot/Bip001_L_Toe0',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh/Bip001_R_Calf',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh/Bip001_R_Calf/Bip001_R_Foot',
  'Bip001/Bip001_Pelvis/Bip001_R_Thigh/Bip001_R_Calf/Bip001_R_Foot/Bip001_R_Toe0',
  'Bip001/Bip001_Pelvis/Bip001_Tail1',
  'Bip001/Bip001_Pelvis/Bip001_Tail1/Bip001_Tail2',
  'Bip001/Bip001_Pelvis/Bip001_Tail1/Bip001_Tail2/Bip001_Tail3',
  'Bip001/Bip001_Pelvis/Bip001_Tail1/Bip001_Tail2/Bip001_Tail3/Bip001_Tail4',
]

export const fishSkeleton = [
  'Fish_spine02',
  'Fish_spine02/Fish_spine03',
  'Fish_spine02/Fish_spine03/Fish_spine04',
  'Fish_spine02/Fish_spine03/Fish_spine04/Fish_spine05',
  'Fish_spine02/Fish_spine01',
]

export const snakeSkeleton = [
  'Bone_spine03',
  'Bone_spine03/Bone_spine04',
  'Bone_spine03/Bone_spine04/Bone_spine05',
  'Bone_spine03/Bone_spine04/Bone_spine05/Bone_spine06',
  'Bone_spine03/Bone_spine04/Bone_spine05/Bone_spine06/Bone_spine07',
  'Bone_spine03/Bone_spine04/Bone_spine05/Bone_spine06/Bone_spine07/Bone_spine08',
  'Bone_spine03/Bone_spine04/Bone_spine05/Bone_spine06/Bone_spine07/Bone_spine08/Bone_spine09',
  'Bone_spine03/Bone_spine02',
  'Bone_spine03/Bone_spine02/Bone_spine01',
  'Bone_spine03/Bone_spine02/Bone_spine01/Bone_head',
  'Bone_spine03/Bone_spine02/Bone_spine01/Bone_head/Bone_mouth',
  'Bone_spine03/Bone_spine02/Bone_spine01/Bone_head/Bone_mouth/Bone_tongue01',
  'Bone_spine03/Bone_spine02/Bone_spine01/Bone_head/Bone_mouth/Bone_tongue01/Bone_tongue02',
  'Bone_spine03/Bone_spine02/Bone_spine01/Bone_head/Bone_mouth/Bone_tongue01/Bone_tongue02/Bone_tongue03',
]

export const simpleSkeleton = ['Bone_root', 'Bone_root/Bone_body']

export function validate3DModel(
  skeleton_type: SkeletonType,
  skeletonNames: string[],
): boolean {
  const skeletonMap: { [key in SkeletonType]: string[] } = {
    [SkeletonType.HUMANOID]: humanoidSkeleton,
    [SkeletonType.REPTILIA]: reptilesSkeleton,
    [SkeletonType.FISH]: fishSkeleton,
    [SkeletonType.SNAKE]: snakeSkeleton,
    [SkeletonType.SIMPLE]: simpleSkeleton,
    // 添加其他骨架类型和对应的骨架数组
  }

  const skeletonArray = skeletonMap[skeleton_type]

  if (!skeletonArray) return true // 如果骨架类型不存在，默认返回true

  if (skeletonNames.length !== skeletonArray.length) return false

  const res = skeletonNames.filter((name) => {
    return skeletonArray.indexOf(name) !== -1
  })

  return res.length === skeletonArray.length
}

export function validateActionModel(
  skeleton_type: SkeletonType,
  skeletonNames: string[],
): boolean {
  const skeletonMap = {
    [SkeletonType.HUMANOID]: humanoidSkeleton,
    [SkeletonType.REPTILIA]: reptilesSkeleton,
    [SkeletonType.FISH]: fishSkeleton,
    [SkeletonType.SNAKE]: snakeSkeleton,
    [SkeletonType.SIMPLE]: simpleSkeleton,
    // 可以在这里添加更多的骨架类型
  }

  const validSkeleton = skeletonMap[skeleton_type]

  if (!validSkeleton) {
    return false
  }

  const res = skeletonNames.filter((name) => validSkeleton.indexOf(name) !== -1)
  return res.length === skeletonNames.length
}
